<template>
    <div>
        <div class="map-mask-bg"></div>
        <div class="select-top">
            <el-select v-model="secSn" placeholder="请选择" size="small"
                class="point-select">
                <el-option
                    v-for="item in vdata"
                    :key="item.sn"
                    :label="item.sn"
                    :value="item.sn">
                </el-option>
            </el-select>
            <el-date-picker
                v-model="datetime"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                size="small"
                :picker-options="datePickerOptions">
            </el-date-picker>
            <el-button size="small" type="primary" @click="checkPoint" style="width: 72px;">搜索</el-button>
        </div>
        <div id="mapDiv" class="mapDiv3"></div>
    </div>
</template>

<script>
import * as methods from "./method.js";
import axios from 'axios'
import moment from 'moment';

export default {
    name: "template.mapbg",
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            map: null,
            markerlist: [],
            CarTrack: {},
            geocode: null,
            address: "",
            beginadress: "",
            endadress: "",
            pointvisible: false,
            defaultdata: [
                {
                    sn: "上海外滩茂悦大酒店",
                    longitude: "121.4885",
                    latitude: "31.2475",
                },
                {
                    sn: "测试点2",
                    longitude: "111",
                    latitude: "25",
                },
                {
                    sn: "测试点3",
                    longitude: "94",
                    latitude: "34",
                },
                {
                    sn: "测试点4",
                    longitude: "86",
                    latitude: "40",
                },
                {
                    sn: "测试点5",
                    longitude: "108",
                    latitude: "40",
                },
                {
                    sn: "测试点6",
                    longitude: "124",
                    latitude: "45",
                },
            ],
            valueMap: [
                { name: "点位名称", key: "sn" },
                { name: "经度", key: "longitude" },
                { name: "纬度", key: "latitude" },
            ],
            apiconfig: {},
            isApi: false,
            exceldata: [],
            selectitem: "",
            scope: {},
            carlist: [],
            secSn: '',
            datetime: '',
            datePickerOptions: {
                disabledDate(time) {
                // 禁用今天之后的日期，只允许选择今日及之前的日期
                    return time.getTime() > Date.now();
                }
            },
            linelist: []
        };
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                this.defaultdata = n;
            }
        },
        defaultdata(n) {
            this.uploadMaker();
        },
        jsondata(n) {
            this.exceldata = n;
        },
    },
    mounted() {
        this.setData()
        this.mapstart();
    },
    methods: {
        ...methods,
        mapstart() {
            var map;
            var zoom = 13;
            var lay;
            var onlyMapLay;
            var config;
            var imageURL;
            var icon;
            var marker;
            var infoWin1;
            var sContent;
            var lng;
            var lat;
            var latlng;
            var label;
            var line;
            var localsearch;
            var countries1 = [];
            var countriesOverlay2 = new T.D3Overlay(init2, redraw2);
            const _this = this;
            this.map = new T.Map("mapDiv");
            this.map.centerAndZoom(new T.LngLat(105, 38), 5);
            //初始化地图对象
            // this.map.setStyle("indigo");
            // this.map.setStyle("black");
            var myfilter = "hue-rotate(180deg) invert(86%) saturate(80%) brightness(137%)"
            //设置主题色
            let example = document.getElementById("mapDiv")
            example.style.filter = myfilter;
            d3.json("https://shop.17886.cn/100000.json", function (data) {
                countries1 = data.features;
                _this.map.addOverLay(countriesOverlay2);
            });
            const pointicon = require("@/assets/mapbg3/point.png");
            this.defaultdata.forEach((item) => {
                let car_icon = new T.Icon({
                    iconUrl: pointicon,
                    iconSize: new T.Point(58.5, 88.5),
                    iconAnchor: new T.Point(29.25, 44.25),
                });
                // 向地图上添加自定义标注
                let car_marker = new T.Marker(new T.LngLat(item.longitude, item.latitude), {
                    icon: car_icon,
                    title: item.sn,
                });
                _this.map.addOverLay(car_marker);
                this.carlist.push(car_marker)
            });
            function init2(sel, transform) {
                var upd1 = sel.selectAll("path.geojson1").data(countries1);
                upd1
                    .enter()
                    .append("path")
                    .attr("class", "geojson1")
                    .attr("stroke", "#1a96ff")
                    .attr("fill", function (d, i) {
                        return d3.rgb(41, 97, 221);
                    })
                    .attr("fill-opacity", ".01")
                    .attr("stroke-opacity", "1")
                    .attr("stroke-width", "3px");
            }
            function redraw2(sel, transform) {
                sel.selectAll("path.geojson1").each(function (d, i) {
                    d3.select(this).attr("d", transform.pathFromGeojson);
                });
            }
            let centerPoint = this.defaultdata.find(item => item.value6 == '是')
            if (centerPoint) {
                setTimeout(() => {
                    this.map.centerAndZoom(new T.LngLat(centerPoint.longitude, centerPoint.latitude), 5);
                }, 2000);
                setTimeout(() => {
                    this.map.centerAndZoom(new T.LngLat(centerPoint.longitude, centerPoint.latitude), 16);
                }, 2800);
            }
        },
        closedialog() {
            this.pointvisible = false;
        },
        uploadMaker() {
            const _this = this;
            this.carlist.forEach(item => {
                this.map.removeOverLay(item)
            })
            this.carlist = []
            const pointicon = require("@/assets/mapbg3/point.png");
            this.defaultdata.forEach((item) => {
                let car_icon = new T.Icon({
                    iconUrl: pointicon,
                    iconSize: new T.Point(58.5, 88.5),
                    iconAnchor: new T.Point(29.25, 44.25),
                });
                // 向地图上添加自定义标注
                let car_marker = new T.Marker(new T.LngLat(item.longitude, item.latitude), {
                    icon: car_icon,
                    title: item.sn,
                });
                this.map.addOverLay(car_marker);
                this.carlist.push(car_marker)
            });
            setTimeout(() => {
                this.map.centerAndZoom(new T.LngLat(this.defaultdata[0].longitude, this.defaultdata[0].latitude), 5);
            }, 2000);
        },
        checkPoint() {

            const nextDay = moment(this.datetime).add(1, 'day').format('YYYY-MM-DD');
            let options = {
                url: 'https://bi.17886.cn/api/tuling/get_coordinates.php',
                params: {
                    sn: this.secSn,
                    start_time: this.datetime,
                    end_time: nextDay
                },
                methods: 'get'
            }
            axios(options).then(res => {
                this.drawline(res.data.data)
            })
            console.log('___datetime', this.secSn, this.datetime)
        },
        drawline(list) {
            if (!list.length) return
            if (this.linelist.length) {
                this.linelist.forEach(item => {
                    this.map.removeOverLay(item)
                })
                this.linelist = []
            }
            const lineoptions = list.map(item => {
                return new T.LngLat(item.longitude, item.latitude)
            })
            const pathStyle = {
                color: "#10FD3D", // 路径颜色
                weight: 5, // 路径宽度
                opacity: 1, // 路径透明度
                lineCap: "round", // 线帽样式
                lineJoin: "round" // 线段连接样式
            };
            const path = new T.Polyline(lineoptions, pathStyle)
            this.map.addOverLay(path)
            this.linelist.push(path)
        }
    },
};
</script>

<style scoped lang="scss">
.mapDiv3 {
    width: 1920px;
    height: 1080px;
    position: absolute;
}

.ys-dialog {
    width: 455px;
    height: 219px;
    background-size: 100% 100%;
    position: absolute;
    bottom: 54px;
    left: calc(50% - 227.5px);
    z-index: 401;
}

.car-title {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 15px;
    color: #f9fbff;
    line-height: 15px;
    margin: 8px 0 0 90px;
}

.title1 {
    margin-top: 38px;
    margin-left: 50px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #a3b1b9;
    line-height: 26px;
    max-width: 378px;

    &+.title1 {
        margin-top: 8px;
    }

    em {
        color: #01a8ff;
    }
}

.point-dialog {
    position: absolute;
    width: 360px;
    height: 192px;
    left: calc(50% - 100px);
    top: calc(50% - 100px);
    pointer-events: auto;
    opacity: 0;
    transition: all 0.5s linear;
    background: url(../../assets/template/temlog.png) no-repeat;
    background-size: 100% 100%;

    .title {
        margin: 16px 0 0 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 22px;
        color: #ffffff;
        line-height: 34px;
        text-shadow: 0px 2px 2px rgba(2, 17, 20, 0.15);
        font-style: italic;
        background: linear-gradient(to bottom, #fff, #d8dff4, #6384d6);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .log-content {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 14px;
        color: #b2c1e7;
        margin: 16px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 24px;
    }
}

.dialog-close {
    position: absolute;
    right: 22px;
    top: 22px;
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.map-mask-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 400;
    pointer-events: none;
    background: rgba(26, 150, 255, 0.2);
    top: 0;
    left: 0;
    mix-blend-mode: color;
}

.select-top {
    width: 900px;
    height: 32px;
    position: absolute;
    left: calc(50% - 450px);
    top: 134px;
    z-index: 401;
    display: flex;
    column-gap: 24px;
}
</style>
<style lang="scss">
.mapDiv3 {
    .tdt-interactive {
        filter: hue-rotate(180deg) invert(100%) saturate(80%) brightness(120%);
    }
}
.select-top {
    .point-select {
        .el-input__inner {
            background: rgba(16, 30, 64, 0.7);
            color: #fff;
            border: 1px solid #279CE8;
        }
    }
    .el-date-editor {
        .el-input__inner {
            background: rgba(16, 30, 64, 0.7);
            color: #fff;
            border: 1px solid #279CE8;
        }
    }
}
</style>